import axios from 'axios';
import * as moment from "moment-timezone";
import Auth from "./Auth";
import { get } from "lodash";


/**
 * Create an Axios Client with defaults
 */
let axiosInstance = axios.create();

axiosInstance.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axiosInstance.defaults.headers.common['Content-Type'] = 'application/json';
axiosInstance.defaults.headers.common['Content-Timezone'] = moment.tz.guess() === 'Asia/Calcutta'
        ? 'Asia/Kolkata'
        : moment.tz.guess();
axiosInstance.defaults.baseURL = process.env.REACT_APP_API_URL + '/api';

export const client = axiosInstance;

/**
 * Request Wrapper with default success/error actions
 */
export const request = function (options: any) {
    const auth = new Auth();

    if ( typeof options?.url === "string" ) {
        options.url = normalizeProviderActionUrl(options.url);
    }

    if ( !options.withoutAuth ) {
        axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${ auth.getToken() }`;
        axiosInstance.defaults.headers.common['Content-Lang'] = get(auth.getUser(), ['app_settings', 'lang']);
    }

    const onSuccess = function (response: any): any {
        return response;
    };

    const onError = function (error: any): any {
        if ( error.response ) {
            if ( error.response.status === 401 ) {
                auth.logout();
                // store.dispatch({ type: AUTH_LOGOUT });
                setTimeout(() => window.location.reload(), 2000);
                return false;
            }

            if ( error.response.status === 500 ) {

            }
        } else {
            // Something else happened while setting up the request
            // triggered the error
            // console.error('Error Message:', error.message);
        }

        return Promise.reject(error.response || error.message);
    };

    return axiosInstance(options)
    .then(onSuccess)
    .catch(onError);
};

const normalizeProviderActionUrl = (url: string): string => {
    const listUnifiedPattern = /^\/suppliers\/(?:alp|vehicle\/logistics)\/(inbound|outbound|reexport|spot)\/loads(?:$|\/(?:create|archived\/list|sync\/list)(?:$|\?)|\?)/;
    const loadActionPattern = /^\/suppliers\/(?:alp|vehicle\/logistics)\/(inbound|outbound|reexport|spot)\/loads\/[^/]+(?:\/(?:sync|reset|accept|reject|confirm\/after\/manufacturer\/approval|update|in\/transit|unload\/request|confirm\/transport\/order|decline\/transport\/order|update\/price))?$/;
    const groupActionPattern = /^\/suppliers\/(?:alp|vehicle\/logistics)\/aviso\/outbound\/loads\/[^/]+(?:\/(?:accept|reset|update|add\/load|in\/transit|unload\/request|cmr|cmrs|sync|remove|detach|destroy)(?:\/[^/]+\/send)?)?$/;
    const groupStorePattern = /^\/suppliers\/(?:alp|vehicle\/logistics)\/aviso\/outbound\/loads\/store$/;
    const groupListPattern = /^\/suppliers\/(?:alp|vehicle\/logistics)\/aviso\/outbound\/groups(?:$|\?)/;
    const groupDetailPattern = /^\/suppliers\/(?:alp|vehicle\/logistics)\/aviso\/outbound\/groups\/[^/]+$/;
    const transportRequestSyncPattern = /^\/suppliers\/(?:alp|vehicle\/logistics)\/orders\/transport\/requests(?:\/sync\/list|\/[^/]+\/sync)$/;
    const damageCasePattern = /^\/suppliers\/(?:alp|vehicle\/logistics)\/order\/damage\/cases(?:\/[^/]+\/(?:sync|upload\/documents|update\/damage\/codes|update\/etr)|\/sync)$/;

    if ( listUnifiedPattern.test(url) ) {
        return url.replace(/^\/suppliers\/(?:alp|vehicle\/logistics)\//, "/suppliers/provider/");
    }

    if (
        loadActionPattern.test(url)
        || groupActionPattern.test(url)
        || groupStorePattern.test(url)
        || groupListPattern.test(url)
        || groupDetailPattern.test(url)
        || transportRequestSyncPattern.test(url)
        || damageCasePattern.test(url)
    ) {
        return url.replace(/^\/suppliers\/(?:alp|vehicle\/logistics)\//, "/suppliers/provider/");
    }

    return url;
};
